import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { Button } from '$lib/components/ui/button';
import { Input } from '$lib/components/ui/input';
import { Label } from '$lib/components/ui/label';
import * as Card from '$lib/components/ui/card';
import { getAdminStats } from '$lib/api/admin';

var root_7 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_5 = $.from_html(`<form class="space-y-4"><div class="space-y-2"><!> <!></div> <!> <!></form>`);
var root_2 = $.from_html(`<!> <!>`, 1);
var root_1 = $.from_html(`<div class="w-full max-w-[400px]"><!></div>`);
var root_12 = $.from_html(`<p class="text-3xl font-bold text-primary"> <span class="text-lg font-normal text-muted-foreground"> </span></p> <p class="text-sm text-muted-foreground mt-1">Total splits</p>`, 1);
var root_14 = $.from_html(`<p class="text-xl font-bold text-primary"> <span class="text-sm font-normal text-muted-foreground"> </span></p> <p class="text-sm text-muted-foreground mt-1">Storage used</p>`, 1);
var root_16 = $.from_html(`<p class="text-xs text-muted-foreground uppercase tracking-wide">Last updated</p> <p class="text-sm font-medium mt-1"> </p>`, 1);
var root_19 = $.from_html(`<tr class="border-b last:border-0"><td class="py-2 px-3 font-mono text-xs"> </td><td class="py-2 px-3 text-muted-foreground"> </td></tr>`);
var root_18 = $.from_html(`<table class="w-full text-sm"><thead><tr class="border-b"><th class="text-left py-2 px-3 font-medium text-muted-foreground">ID hash</th><th class="text-left py-2 px-3 font-medium text-muted-foreground">Created</th></tr></thead><tbody></tbody></table>`);
var root_22 = $.from_html(`<tr class="border-b last:border-0"><td class="py-2 px-3 font-mono text-xs"> </td><td class="py-2 px-3 text-muted-foreground"> </td><td class="py-2 px-3 text-muted-foreground"> </td></tr>`);
var root_21 = $.from_html(`<table class="w-full text-sm"><thead><tr class="border-b"><th class="text-left py-2 px-3 font-medium text-muted-foreground">ID hash</th><th class="text-left py-2 px-3 font-medium text-muted-foreground">Last updated</th><th class="text-left py-2 px-3 font-medium text-muted-foreground">Created</th></tr></thead><tbody></tbody></table>`);
var root_25 = $.from_html(`<tr class="border-b last:border-0"><td class="py-2 px-3 font-mono text-xs"> </td><td class="py-2 px-3 text-muted-foreground"> </td><td class="py-2 px-3 text-muted-foreground"> </td></tr>`);
var root_24 = $.from_html(`<table class="w-full text-sm"><thead><tr class="border-b"><th class="text-left py-2 px-3 font-medium text-muted-foreground">ID hash</th><th class="text-left py-2 px-3 font-medium text-muted-foreground">Last updated</th><th class="text-left py-2 px-3 font-medium text-muted-foreground">Created</th></tr></thead><tbody></tbody></table>`);
var root_9 = $.from_html(`<div class="w-full flex justify-end"><!></div> <div class="w-full grid grid-cols-2 sm:grid-cols-3 gap-3"><!> <!> <!></div> <div class="w-full"><h2 class="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">Oldest created splits</h2> <!></div> <div class="w-full"><h2 class="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">Oldest updated splits</h2> <!></div> <div class="w-full"><h2 class="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">Most recently updated splits</h2> <!></div>`, 1);
var root = $.from_html(`<div class="flex flex-col items-center space-y-6 w-full max-w-[900px] mx-auto py-8 px-4"><header class="text-center"><h1 class="text-2xl font-bold text-primary">Admin</h1> <p class="text-muted-foreground mt-1 text-sm">FairNSquare administration</p></header> <!></div>`);

export default function Admin($$anchor, $$props) {
	$.push($$props, true);

	// Admin page — password-protected stats view
	// Issue #107: Not linked from the main navigation
	const SESSION_KEY = 'admin_token';

	let token = $.state($.proxy(sessionStorage.getItem(SESSION_KEY) ?? ''));
	let tokenInput = $.state('');
	let stats = $.state(null);
	let isLoading = $.state(false);
	let errorMessage = $.state(null);

	// If a token is stored in sessionStorage, try to load stats immediately
	$.user_effect(() => {
		if ($.get(token)) {
			doLoadStats($.get(token));
		}
	});

	async function handleLogin() {
		if (!$.get(tokenInput).trim()) return;

		$.set(errorMessage, null);
		await doLoadStats($.get(tokenInput).trim());
	}

	async function doLoadStats(t) {
		$.set(isLoading, true);
		$.set(errorMessage, null);

		try {
			const result = await getAdminStats(t);

			$.set(stats, result, true);
			$.set(token, t, true);
			sessionStorage.setItem(SESSION_KEY, t);
		} catch(err) {
			const apiError = err;

			$.set(stats, null);

			if (apiError.status === 401) {
				$.set(errorMessage, 'Invalid password.');
				$.set(token, '');
				sessionStorage.removeItem(SESSION_KEY);
			} else if (apiError.status === 503) {
				$.set(errorMessage, 'Admin access is not configured on this server.');
			} else {
				$.set(errorMessage, apiError.detail || 'Failed to load admin stats.', true);
			}
		} finally {
			$.set(isLoading, false);
		}
	}

	function handleLogout() {
		$.set(stats, null);
		$.set(token, '');
		$.set(tokenInput, '');
		sessionStorage.removeItem(SESSION_KEY);
	}

	function formatDate(iso) {
		if (!iso) return '—';

		return new Date(iso).toLocaleString();
	}

	function formatBytes(bytes) {
		if (bytes >= 1024 * 1024 * 1024) return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
		if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
		if (bytes >= 1024) return (bytes / 1024).toFixed(2) + ' KB';

		return bytes + ' B';
	}

	// Oldest-created: first 5 splits sorted by createdAt asc
	const oldestCreated = $.derived(() => $.get(stats)
		? [...$.get(stats).splits].sort((a, b) => a.createdAt.localeCompare(b.createdAt)).slice(0, 5)
		: []);

	// Oldest-updated: first 5 splits sorted by updatedAt asc (least recently touched)
	const oldestUpdated = $.derived(() => $.get(stats)
		? [...$.get(stats).splits].sort((a, b) => a.updatedAt.localeCompare(b.updatedAt)).slice(0, 5)
		: []);

	// Most-recently-updated: first 5 splits sorted by updatedAt desc
	const mostRecentlyUpdated = $.derived(() => $.get(stats)
		? [...$.get(stats).splits].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 5)
		: []);

	var div = root();
	var node = $.sibling($.child(div), 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_1 = root_1();
			var node_1 = $.child(div_1);

			$.component(node_1, () => Card.Root, ($$anchor, Card_Root) => {
				Card_Root($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment = root_2();
						var node_2 = $.first_child(fragment);

						$.component(node_2, () => Card.Header, ($$anchor, Card_Header) => {
							Card_Header($$anchor, {
								children: ($$anchor, $$slotProps) => {
									var fragment_1 = $.comment();
									var node_3 = $.first_child(fragment_1);

									$.component(node_3, () => Card.Title, ($$anchor, Card_Title) => {
										Card_Title($$anchor, {
											children: ($$anchor, $$slotProps) => {
												$.next();

												var text = $.text('Sign in');

												$.append($$anchor, text);
											},

											$$slots: { default: true }
										});
									});

									$.append($$anchor, fragment_1);
								},

								$$slots: { default: true }
							});
						});

						var node_4 = $.sibling(node_2, 2);

						$.component(node_4, () => Card.Content, ($$anchor, Card_Content) => {
							Card_Content($$anchor, {
								children: ($$anchor, $$slotProps) => {
									var form = root_5();
									var div_2 = $.child(form);
									var node_5 = $.child(div_2);

									Label(node_5, {
										for: 'admin-password',

										children: ($$anchor, $$slotProps) => {
											$.next();

											var text_1 = $.text('Password');

											$.append($$anchor, text_1);
										},

										$$slots: { default: true }
									});

									var node_6 = $.sibling(node_5, 2);

									Input(node_6, {
										id: 'admin-password',
										type: 'password',
										placeholder: 'Admin password',

										get disabled() {
											return $.get(isLoading);
										},

										class: 'min-h-[44px]',
										autocomplete: 'current-password',

										get value() {
											return $.get(tokenInput);
										},

										set value($$value) {
											$.set(tokenInput, $$value, true);
										}
									});

									$.reset(div_2);

									var node_7 = $.sibling(div_2, 2);

									{
										var consequent = ($$anchor) => {
											var p = root_7();
											var text_2 = $.child(p, true);

											$.reset(p);
											$.template_effect(() => $.set_text(text_2, $.get(errorMessage)));
											$.append($$anchor, p);
										};

										$.if(node_7, ($$render) => {
											if ($.get(errorMessage)) $$render(consequent);
										});
									}

									var node_8 = $.sibling(node_7, 2);

									{
										let $0 = $.derived(() => $.get(isLoading) || !$.get(tokenInput).trim());

										Button(node_8, {
											type: 'submit',

											get disabled() {
												return $.get($0);
											},

											class: 'w-full min-h-[44px]',

											children: ($$anchor, $$slotProps) => {
												$.next();

												var text_3 = $.text();

												$.template_effect(() => $.set_text(text_3, $.get(isLoading) ? 'Signing in…' : 'Sign in'));
												$.append($$anchor, text_3);
											},

											$$slots: { default: true }
										});
									}

									$.reset(form);

									$.event('submit', form, (e) => {
										e.preventDefault();
										handleLogin();
									});

									$.append($$anchor, form);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_1);
			$.append($$anchor, div_1);
		};

		var alternate = ($$anchor) => {
			var fragment_3 = root_9();
			var div_3 = $.first_child(fragment_3);
			var node_9 = $.child(div_3);

			Button(node_9, {
				variant: 'outline',
				onclick: handleLogout,
				class: 'min-h-[44px]',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_4 = $.text('Sign out');

					$.append($$anchor, text_4);
				},

				$$slots: { default: true }
			});

			$.reset(div_3);

			var div_4 = $.sibling(div_3, 2);
			var node_10 = $.child(div_4);

			$.component(node_10, () => Card.Root, ($$anchor, Card_Root_1) => {
				Card_Root_1($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment_4 = $.comment();
						var node_11 = $.first_child(fragment_4);

						$.component(node_11, () => Card.Content, ($$anchor, Card_Content_1) => {
							Card_Content_1($$anchor, {
								class: 'py-4 text-center',

								children: ($$anchor, $$slotProps) => {
									var fragment_5 = root_12();
									var p_1 = $.first_child(fragment_5);
									var text_5 = $.child(p_1);
									var span = $.sibling(text_5);
									var text_6 = $.child(span);

									$.reset(span);
									$.reset(p_1);
									$.next(2);

									$.template_effect(() => {
										$.set_text(text_5, `${$.get(stats).totalSplits ?? ''} `);
										$.set_text(text_6, `/ ${$.get(stats).splitCountLimit ?? ''}`);
									});

									$.append($$anchor, fragment_5);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_4);
					},

					$$slots: { default: true }
				});
			});

			var node_12 = $.sibling(node_10, 2);

			$.component(node_12, () => Card.Root, ($$anchor, Card_Root_2) => {
				Card_Root_2($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment_6 = $.comment();
						var node_13 = $.first_child(fragment_6);

						$.component(node_13, () => Card.Content, ($$anchor, Card_Content_2) => {
							Card_Content_2($$anchor, {
								class: 'py-4 text-center',

								children: ($$anchor, $$slotProps) => {
									var fragment_7 = root_14();
									var p_2 = $.first_child(fragment_7);
									var text_7 = $.child(p_2);
									var span_1 = $.sibling(text_7);
									var text_8 = $.child(span_1);

									$.reset(span_1);
									$.reset(p_2);
									$.next(2);

									$.template_effect(
										($0, $1) => {
											$.set_text(text_7, `${$0 ?? ''} `);
											$.set_text(text_8, `/ ${$1 ?? ''}`);
										},
										[
											() => formatBytes($.get(stats).usedStorageBytes),
											() => formatBytes($.get(stats).maxStorageBytes)
										]
									);

									$.append($$anchor, fragment_7);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_6);
					},

					$$slots: { default: true }
				});
			});

			var node_14 = $.sibling(node_12, 2);

			$.component(node_14, () => Card.Root, ($$anchor, Card_Root_3) => {
				Card_Root_3($$anchor, {
					class: 'col-span-2 sm:col-span-1',

					children: ($$anchor, $$slotProps) => {
						var fragment_8 = $.comment();
						var node_15 = $.first_child(fragment_8);

						$.component(node_15, () => Card.Content, ($$anchor, Card_Content_3) => {
							Card_Content_3($$anchor, {
								class: 'py-4',

								children: ($$anchor, $$slotProps) => {
									var fragment_9 = root_16();
									var p_3 = $.sibling($.first_child(fragment_9), 2);
									var text_9 = $.child(p_3, true);

									$.reset(p_3);
									$.template_effect(($0) => $.set_text(text_9, $0), [() => formatDate($.get(stats).lastUpdated)]);
									$.append($$anchor, fragment_9);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_8);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_4);

			var div_5 = $.sibling(div_4, 2);
			var node_16 = $.sibling($.child(div_5), 2);

			$.component(node_16, () => Card.Root, ($$anchor, Card_Root_4) => {
				Card_Root_4($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment_10 = $.comment();
						var node_17 = $.first_child(fragment_10);

						$.component(node_17, () => Card.Content, ($$anchor, Card_Content_4) => {
							Card_Content_4($$anchor, {
								class: 'py-0',

								children: ($$anchor, $$slotProps) => {
									var table = root_18();
									var tbody = $.sibling($.child(table));

									$.each(tbody, 21, () => $.get(oldestCreated), (s) => s.idHash, ($$anchor, s) => {
										var tr = root_19();
										var td = $.child(tr);
										var text_10 = $.child(td, true);

										$.reset(td);

										var td_1 = $.sibling(td);
										var text_11 = $.child(td_1, true);

										$.reset(td_1);
										$.reset(tr);

										$.template_effect(
											($0) => {
												$.set_text(text_10, $.get(s).idHash);
												$.set_text(text_11, $0);
											},
											[() => formatDate($.get(s).createdAt)]
										);

										$.append($$anchor, tr);
									});

									$.reset(tbody);
									$.reset(table);
									$.append($$anchor, table);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_10);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_5);

			var div_6 = $.sibling(div_5, 2);
			var node_18 = $.sibling($.child(div_6), 2);

			$.component(node_18, () => Card.Root, ($$anchor, Card_Root_5) => {
				Card_Root_5($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment_11 = $.comment();
						var node_19 = $.first_child(fragment_11);

						$.component(node_19, () => Card.Content, ($$anchor, Card_Content_5) => {
							Card_Content_5($$anchor, {
								class: 'py-0',

								children: ($$anchor, $$slotProps) => {
									var table_1 = root_21();
									var tbody_1 = $.sibling($.child(table_1));

									$.each(tbody_1, 21, () => $.get(oldestUpdated), (s) => s.idHash, ($$anchor, s) => {
										var tr_1 = root_22();
										var td_2 = $.child(tr_1);
										var text_12 = $.child(td_2, true);

										$.reset(td_2);

										var td_3 = $.sibling(td_2);
										var text_13 = $.child(td_3, true);

										$.reset(td_3);

										var td_4 = $.sibling(td_3);
										var text_14 = $.child(td_4, true);

										$.reset(td_4);
										$.reset(tr_1);

										$.template_effect(
											($0, $1) => {
												$.set_text(text_12, $.get(s).idHash);
												$.set_text(text_13, $0);
												$.set_text(text_14, $1);
											},
											[
												() => formatDate($.get(s).updatedAt),
												() => formatDate($.get(s).createdAt)
											]
										);

										$.append($$anchor, tr_1);
									});

									$.reset(tbody_1);
									$.reset(table_1);
									$.append($$anchor, table_1);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_11);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_6);

			var div_7 = $.sibling(div_6, 2);
			var node_20 = $.sibling($.child(div_7), 2);

			$.component(node_20, () => Card.Root, ($$anchor, Card_Root_6) => {
				Card_Root_6($$anchor, {
					children: ($$anchor, $$slotProps) => {
						var fragment_12 = $.comment();
						var node_21 = $.first_child(fragment_12);

						$.component(node_21, () => Card.Content, ($$anchor, Card_Content_6) => {
							Card_Content_6($$anchor, {
								class: 'py-0',

								children: ($$anchor, $$slotProps) => {
									var table_2 = root_24();
									var tbody_2 = $.sibling($.child(table_2));

									$.each(tbody_2, 21, () => $.get(mostRecentlyUpdated), (s) => s.idHash, ($$anchor, s) => {
										var tr_2 = root_25();
										var td_5 = $.child(tr_2);
										var text_15 = $.child(td_5, true);

										$.reset(td_5);

										var td_6 = $.sibling(td_5);
										var text_16 = $.child(td_6, true);

										$.reset(td_6);

										var td_7 = $.sibling(td_6);
										var text_17 = $.child(td_7, true);

										$.reset(td_7);
										$.reset(tr_2);

										$.template_effect(
											($0, $1) => {
												$.set_text(text_15, $.get(s).idHash);
												$.set_text(text_16, $0);
												$.set_text(text_17, $1);
											},
											[
												() => formatDate($.get(s).updatedAt),
												() => formatDate($.get(s).createdAt)
											]
										);

										$.append($$anchor, tr_2);
									});

									$.reset(tbody_2);
									$.reset(table_2);
									$.append($$anchor, table_2);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_12);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_7);
			$.append($$anchor, fragment_3);
		};

		$.if(node, ($$render) => {
			if (!$.get(stats)) $$render(consequent_1); else $$render(alternate, false);
		});
	}

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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